module.exports = __webpack_public_path__ + "static/media/icon-worldwide.118c87a5.svg";